import React from 'react';
import { Modal, ButtonToolbar, Button, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { currentTimezoneAggr } from '../../../../../shared/helpers/Dates';
import Hook from '../../../../../shared/hooks';

// The brand's own status decisions on a prospect, from EntityHistory (IL-7512). Used by the
// Prospects list and the Dashboard's shield; `prospectId` is all either needs to pass.
const StatusHistoryModal = ({
  modal,
  setModalVisible,
  prospectId,
}) => {
  const { records, loading, error } = Hook.useEntityHistoryHook({
    url: '/api/brand/content/get-entity-history',
    entity: 'Prospect',
    id: prospectId,
    field: 'approvalStatus.brand.status',
    isOpen: modal,
    // This modal rendered the embedded array in insertion order.
    oldestFirst: true,
  });

  return (
    <Modal
      isOpen={modal}
      toggle={() => setModalVisible(false)}
    >
      <ModalHeader toggle={() => setModalVisible(false)} tag="h4" className="pl-0">Brand Status History</ModalHeader>
      <div className="mt-3">
        {loading ? <div className="mb-3">Loading...</div> : null}
        {error ? <div className="mb-3 text-danger">{error}</div> : null}
        {!loading && !error && records.length === 0 ? <div className="mb-3 text-muted">No status changes recorded.</div> : null}
        {records.map(item => (
          <div key={item._id}>
            <div><strong>{moment(item.changedAt).format('M/D/YYYY h:mm A')} {currentTimezoneAggr()}</strong></div>
            <div className="pl-3">{item.changedBy || 'AUTOMATION'} - {item.oldValue || ''} changed to {item.newValue}</div>
          </div>
        ))}
      </div>
      <ButtonToolbar className="modal__footer">
        <Button className="modal_cancel btn-sm" color="secondary" onClick={() => setModalVisible(false)}>Close</Button>
      </ButtonToolbar>
    </Modal>
  );
};

StatusHistoryModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  setModalVisible: PropTypes.func.isRequired,
  prospectId: PropTypes.string,
};

StatusHistoryModal.defaultProps = {
  prospectId: null,
};

export default StatusHistoryModal;
